import { VeriUploadFile } from "libs/shared-components/src/components/form-controls/upload/VeriDropZone/VeriDropZone.types";
import { Dict, ModelId } from "../../../../defines";
import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import {
  CreateDocumentsZipJobOutputModel,
  DocumentModel,
} from "../../../models";
import { JsonApiSingleResponse } from "../../../types";

export default function apiDocumentModel(opts: ApiModelOptions<DocumentModel>) {
  const model = ApiModel<DocumentModel>("document", {
    usePlacement: true,
    ...opts,
  });

  const downloadDocument = async (documentId: string, fileName: string) => {
    return await model.handler.downloadDocument(documentId, fileName);
  };

  const startZipDownloadJob = async (
    documentIds: number[],
    managerId: number,
  ) => {
    return (
      await model.apiClient.post<
        JsonApiSingleResponse<CreateDocumentsZipJobOutputModel>
      >(
        "/documents/zip/job",
        {
          documentIds,
          managerId,
        },
        true,
      )
    )?.data;
  };

  const downloadZipDocuments = async (fileName: string) => {
    return await model.apiClient.downloadAndSaveFile(
      `/documents/zip/download/${fileName}`,
      fileName,
    );
  };

  /** @deprecated
   * We should no longer use placements to upload documents.
   * Use uploadApiDocument instead
   */
  const uploadDocument = async (file: any, queryParams: Dict) => {
    const response = await model.handler.uploadRequest(
      "documents",
      file,
      {
        filename: file.name,
        ...queryParams,
      },
      () => {
        //nothing
      },
      true,
    );

    return response as { data: DocumentModel };
  };

  const uploadApiDocument = async (file: VeriUploadFile, params: Dict = {}) => {
    if (!file.file) {
      throw new Error("Missing file");
    }

    const formData = new FormData();
    formData.append("file", file.file, file.name);
    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });

    await model.apiClient.uploadApiRequest("documents", formData);
  };

  const getDocumentsByVerificationId = async (verificationId: ModelId) => {
    return await model.getMany(undefined, { verification_id: verificationId });
  };

  return {
    ...model,
    downloadDocument,
    uploadDocument,
    uploadApiDocument,
    startZipDownloadJob,
    downloadZipDocuments,
    getDocumentsByVerificationId,
  };
}
